import React from 'react';
import { navigate } from '@reach/router';
import RouteBuilder from 'src/utils/routing/RouteBuilder';
import { useRouteBuilder } from 'src/utils/routing/RouteBuilderContext';
import { FunctionComponentReturnType } from 'src/types/sharedReact';
import 'src/pages/NotFoundPage/NotFoundPage.css';

import '@cof/dxo-ui-button';

const NOT_FOUND_HEADING = 'Page Not Found';
const NOT_FOUND_DESCRIPTION = "We couldn't find the page you were looking for.";
const RETURN_BUTTON_TEXT = '← Return to Home';

/**
 * NotFoundPage - 404 / Unknown Route
 *
 * Renders when the user navigates to an unknown URL. Provides a "Return to
 * Home" tertiary button matching the same pattern as NotAuthorizedPage.
 */
function NotFoundPage(): FunctionComponentReturnType {
	const routeBuilder: RouteBuilder = useRouteBuilder();

	const handleReturn = (): void => {
		const isOnDevex = typeof window !== 'undefined'
			&& window.location.hostname.includes('developer');
		navigate(isOnDevex ? routeBuilder.client.toHomePageV2() : routeBuilder.client.toHomePage());
	};

	return (
		<div className="not-found-page">
			<div className="not-found-content">
				<h1>{NOT_FOUND_HEADING}</h1>
				<p>{NOT_FOUND_DESCRIPTION}</p>
				<div className="not-found-return-button" onClick={handleReturn}>
					<dxo-ui-button
						style-variant="grv-button tertiary"
						id="copp-button-not-found-return"
						name="return-to-home"
						text={RETURN_BUTTON_TEXT}
						type="button"
					/>
				</div>
			</div>
		</div>
	);
}

export default NotFoundPage;
